import React, {useRef, useMemo, useCallback, useEffect} from 'react';
import {useSelector} from 'react-redux';
import fp from 'lodash/fp';

import MaterialTable from 'material-table';
import {Button, makeStyles} from '@material-ui/core';
import {useApi} from 'aauth/components/Api';
import LoginForm from 'aauth/components/LoginForm';
import {selectProviders} from 'aauth/ducks/jsonapi';

const useStyles = makeStyles(theme => ({
    detailPanel: {
        padding: theme.spacing(2),
    }
}));

const columns = api => [
    {title: 'App ID', field: 'attributes.app_id'},
    {title: 'Plugin', field: 'attributes.plugin_id'},
    {
        title: 'Login', render: rowData => {
            const redirect_uri = new URL('/callback', window.location.href);
            const authorizeLink = api.authorizeLink(rowData.links.authorize, {
                redirect_uri, intent: 'login'});
            return <a href={authorizeLink.toString()}>Login</a>
        }
    },
    {
        title: 'Link', render: rowData => {
            const redirect_uri = new URL('/callback', window.location.href);
            const authorizeLink = api.authorizeLink(rowData.links.authorize, {
                redirect_uri, intent: 'link'});
            return <Button href={authorizeLink.toString()}>Link</Button>
        }
    },

];

function ProviderDetail({provider}) {
    const classes = useStyles();

    if(provider.attributes.plugin_id !== 'password') return null;
    return (
        <div className={classes.detailPanel}>
            <LoginForm provider={provider}/>
        </div>
    );
}

export default function ProviderTable() {
    const api = useApi();
    const providers = useSelector(selectProviders);
    const tableRef = useRef();
    
    const tableData = useMemo(() => fp.map(
        p => ({...p}),
        providers
    ), [providers]);

    const fetchData = useCallback(async options => {
        let {
            filters, orderBy, orderDirection, page, pageSize, search, 
            totalCount, ...rest
        } = options;
        let data = await api.fetchJson(api.directory.data.links['rest.providers']);
        return {
            data: fp.map(row => ({...row}), data.data), // prevent mutation of state
            totalCount: data.meta.total,
            page
        }
    }, [api, providers]);


    const refresh = useCallback(() => {
        tableRef.current.onQueryChange();
    }, [tableRef])

    const _columns = useMemo(() => columns(api), [api]);

    return (
        <MaterialTable 
            title="Auth Providers"
            tableRef={tableRef}
            columns={_columns}
            data={fetchData}
            options={{
                search: false,
            }}
            detailPanel={rowData => <ProviderDetail provider={rowData}/>}
            actions={[
                {
                    icon: 'refresh', tooltip: 'Refresh', isFreeAction: true, 
                    onClick: refresh
                }
            ]}
        />
    );
}


